<template>
  <page-outline :title="$t('attachments.import_attach')" iconF7="list_bullet">

    <template slot="pageContent">
      <b-row>
        <b-col sm="6" class="form-group">
          <label style="width: 100%; margin-bottom: 0px; margin-top: -4px;">
            <div class="fileContainer">
              {{ $t('common.chse_file') }}
              <input ref="fileInput" type="file" name="file2" id="file2" @change="onFileChange"></input>
            </div>
          </label>
          <input v-model="attachmentName"
            type="text" name="filename"
            class="form-control"
            :placeholder="attachmentsImport_chseFile"
            disabled>
          </input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input isMandatory
            :inputLabel="$t('businessDocuments.document_type')"
            inputType="listeSelect" :mandatoryErrorIndicator="fileTypeSelectedError">
            <select class="form-control" id="sel2" readonly v-model="fileTypeSelected">
              <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
              <option v-for="fileType in fileTypeList" :key="fileType.fileTypeValue"
                :value="fileType.fileTypeValue">
                {{ $t(fileType.fileTypeLabel) }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="reference"
            :inputLabel="$t('common.rfrnc')"
            :placeholderValue="attachmentsImport_Reference">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9">
          <f7-button
            class="milkyBlockBlack importAttachmentButton button-action"
            @click="importAttachment">
            <f7-icon f7="list_bullet"></f7-icon>
            <span>{{ $t('common.imprt') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
    <!-- <canvas id="pdf-canvas" width="1000" class="hiddenElement"></canvas> -->
  </page-outline>
</template>

<script>
import axios from 'axios'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import documentSerialize from '@/helpers/documentSerialize.json'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'importAttachement',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data  () {
    return {
      isSmartphone: false,
      fileTypeSelected: '',
      fileTypeSelectedError: false,
      fileTypeList: [{
        fileTypeValue: 1,
        fileTypeLabel: 'businessDocuments.cost_estimate'
      }, {
        fileTypeValue: 0,
        fileTypeLabel: 'attachments.invce'
      }],
      mimeType: '',
      attachment: '',
      attachmentName: '',
      reference: '',
      newOCRTextData: '',
      service: ''
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.attachmentsImport_ImportFile = this.$i18n.t('attachments.import_file')
    this.attachmentsImport_Reference = this.$i18n.t('common.rfrnc')
    this.attachmentsImport_chseFile = this.$i18n.t('common.chse_file')
    this.fileTypeSelected = ''
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
    this.reference = ''
    this.fileInput = ''
    this.service = this.$engine.user.currentService.name
    // this.$refs.fileInput.value = null

    // Generate fileTypeList from documentSerialize
    let keys = Object.keys(documentSerialize)
    for (var i = 0; i < keys.length; i++) {
      let fileType = {}
      fileType.fileTypeValue = keys[i]
      fileType.fileTypeLabel = documentSerialize[keys[i]].label
      fileType.disabled = documentSerialize[keys[i]].disabled
      this.fileTypeList.push(fileType)
    }
  },
  methods: {
    importAttachment () {
      let that = this
      /* TLV 06/01/2020
      * Lors d'un import le type d'attachment est à présent déterminé par le service
      * Sur les RTP (service vert) --> Invoice
      * Sur les DP (service bleu) --> Refund
      */
      // if (this.service === 'Direct Payments') {
      //   this.fileTypeSelected = '1'
      // } else {
      //   this.fileTypeSelected = '0'
      // }
      if (that.fileTypeSelected !== '' && that.attachment !== '' && that.attachmentName !== '') {
        this.$f7.showPreloader(this.$i18n.t('common.imprtng'))
        that.$engine.attachments
          .uploadWebapp(
            that.reference,
            this.fileTypeSelected,
            that.attachment.split(';')[0].split('/')[1],
            that.attachmentName,
            that.attachment,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            'test',
            ''
          )
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              that.fileTypeSelected = ''
              that.mimeType = ''
              that.attachment = ''
              that.attachmentName = ''
              that.reference = ''
              that.newOCRTextData = ''
              that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
              // document.getElementById('file2').value = ''
              that.$bus.$emit('refresh-cache-attachments')
              that.$f7.modal({
                title: this.$i18n.t('attachments.attchmnt_imprtd'),
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                loadPage(that, {url: '/attachments/', ignoreCache: true})
                // that.$f7.mainView.router.back()
                // loadPage(that, {url: '/attachments/'})
              }, 2000)
            }
          })
          .catch(error => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            this.handleError(error) // mixins errorHandlerMixins
          })
        // var pdfData = atob(this.attachment.split(',')[1])
        // var loadingTask = PDFJS.getDocument({data: pdfData})
        // var textDataPromise = loadingTask.promise.then(function (pdf) {
        //   var pageNumber = 1
        //   return pdf.getPage(pageNumber).then(function (page) {
        //     return page.getTextContent().then(function (text) {
        //       return text.items.map(function (s) { return s.str }).join('\n')
        //     })
        //   })
        // }, function (reason) {
        //   console.error(reason)
        // })
        // .catch(error => {
        //   errorMessageAlert(error, that)
        // })
        // textDataPromise.then(function (textData) {
        //   that.$engine.attachments
        //     .uploadWebapp(
        //       that.reference,
        //       0,
        //       that.attachment.split(';')[0].split('/')[1],
        //       that.attachmentName,
        //       that.attachment,
        //       // that.attachment.split(',')[1],
        //       // that.newOCRTextData,
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       '',
        //       'test',
        //       ''
        //       // document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).replace(/^data:\w+\/\w+;base64,/, '')
        //     )
        //     .then(response => {
        //       that.$f7.closeModal()
        //       that.$f7.hidePreloader()
        //       that.status = response.status
        //       if (response.status === 200) {
        //         that.fileTypeSelected = ''
        //         that.mimeType = ''
        //         that.attachment = ''
        //         that.attachmentName = ''
        //         that.reference = ''
        //         that.newOCRTextData = ''
        //         that.$$(that.$$('#file2')[that.$$('#file2').length - 1]).val('')
        //         // document.getElementById('file2').value = ''
        //         that.$bus.$emit('refresh-cache-attachments')
        //         that.$f7.modal({
        //           title: 'Attachment imported',
        //           text: '<span class="preloader"></span>'
        //         })
        //         setTimeout(function () {
        //           that.$f7.closeModal()
        //           // loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
        //           loadPage(that, {url: '/attachments/', ignoreCache: true})
        //           // that.$f7.mainView.router.back()
        //           // loadPage(that, {url: '/attachments/'})
        //         }, 2000)
        //       }
        //     })
        //     .catch(error => {
        //       errorMessageAlert(error, that)
        //     })
        // })
        // .catch(error => {
        //   errorMessageAlert(error, that)
        // })
        // Code OCR
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 2000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '2MB', this.$i18n.t('creation_forms.file_size_exeeded'))
      }

      // var pdfUrl = URL.createObjectURL(files[0])
      // var canvas = document.getElementById('pdf-canvas')
      // PDFJS.getDocument({ url: pdfUrl })
      // .then(function (pdfDoc) {
      //   pdfDoc.getPage(1)
      //   .then(function (page) {
      //     var scaleRequired = canvas.width / page.getViewport(1).width
      //     var viewport = page.getViewport(scaleRequired)
      //     canvas.height = viewport.height
      //     var renderContext = {
      //       canvasContext: canvas.getContext('2d'),
      //       viewport: viewport
      //     }
      //     page.render(renderContext)
      //     .then(function () {
      //     })
      //   })
      // })
      // TODO: OCR
      // if (that.$engine.settings.get().ocrActivation === '1') {
      //   that.$$(that.$$('.progressbarListItem')[that.$$('.progressbarListItem').length - 1]).show()
      //   that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).show()
      //   that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).attr('disabled', 'disabled')
      //   var pdfUrl = URL.createObjectURL(files[0])
      //   var canvas = document.getElementById('pdf-canvas')
      //   PDFJS.getDocument({ url: pdfUrl })
      //   .then(function (pdfDoc) {
      //     pdfDoc.getPage(1)
      //     .then(function (page) {
      //       var scaleRequired = canvas.width / page.getViewport(1).width
      //       var viewport = page.getViewport(scaleRequired)
      //       canvas.height = viewport.height
      //       var renderContext = {
      //         canvasContext: canvas.getContext('2d'),
      //         viewport: viewport
      //       }
      //       page.render(renderContext)
      //       .then(function () {
      //         // that.localOCRService()
      //         that.remoteOCRService()
      //         // console.log('----------OK----------')
      //       })
      //     })
      //   })
      // }
      // TODO: OCR
      /* eslint-enable no-undef */
    },
    remoteOCRService () {
      let that = this
      that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('Recognizing text...')
      axios.post('http://192.168.5.42/character/recognize', {
        method: 'vect+nn',
        preProcess: '',
        language: '',
        whiteList: '',
        pageSegmentationMode: '4',
        imageType: document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).split(';')[0].replace(/^data:/, ''),
        imageBase64: document.getElementById('pdf-canvas').toDataURL('image/jpeg', 0.85).replace(/^data:\w+\/\w+;base64,/, '')
      })
      .then(function (response) {
        // console.log('-----------remoteOCRService-----------')
        // console.log(response.data.text)
        that.newOCRTextData = response.data.text
        that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
        that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
        that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    localOCRService () {
      /* eslint-disable no-undef */
      // let that = this
      // if (that.$f7.device.os === 'android') {
      //   Tesseract.workerOptions.workerPath = 'file:///android_asset/www/static/ocr/worker.js'
      //   Tesseract.workerOptions.langPath = 'file:///android_asset/www/static/ocr/tessdata/'
      //   Tesseract.workerOptions.corePath = 'file:///android_asset/www/static/ocr/index.js'
      //
      //   Tesseract.recognize(document.getElementById('pdf-canvas'), {
      //     lang: 'eng'
      //   })
      //   .progress(function (packet) {
      //     console.info(packet)
      //     if (packet.status === '') {
      //     } else if (packet.status === 'loading tesseract core') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
      //     } else if (packet.status === 'initializing tesseract') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
      //     } else if (packet.status === 'downloading eng.traineddata.gz') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
      //     } else if (packet.status === 'unzipping eng.traineddata.gz') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
      //     } else if (packet.status === 'loading eng.traineddata') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
      //     } else if (packet.status === 'initializing api') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
      //     } else if (packet.status === 'recognizing text') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
      //     }
      //     that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
      //   })
      //   .then(function (data) {
      //     that.newOCRTextData = data.text
      //     that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
      //     that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
      //     that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
      // } else if (that.$f7.device.os === 'ios') {
      //   // Tesseract.workerOptions.workerPath = 'https://cdn.rawgit.com/naptha/tesseract.js/1.0.10/dist/worker.js'
      //   // Tesseract.workerOptions.langPath = 'https://cdn.rawgit.com/naptha/tessdata/gh-pages/3.02/'
      //   // Tesseract.workerOptions.corePath = 'https://cdn.rawgit.com/naptha/tesseract.js-core/0.1.0/index.js'
      //   // TODO
      //   window.resolveLocalFileSystemURL(cordova.file.applicationDirectory, function (entry) {
      //     Tesseract.workerOptions.workerPath = entry.nativeURL + 'www/static/ocr/worker.js'
      //     Tesseract.workerOptions.langPath = entry.nativeURL + 'www/static/ocr/tessdata/'
      //     Tesseract.workerOptions.corePath = entry.nativeURL + 'www/static/ocr/index.js'
      //
      //     Tesseract.recognize(document.getElementById('pdf-canvas'), {
      //       lang: 'eng'
      //     })
      //     .progress(function (packet) {
      //       console.info(packet)
      //       if (packet.status === '') {
      //       } else if (packet.status === 'loading tesseract core') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
      //       } else if (packet.status === 'initializing tesseract') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
      //       } else if (packet.status === 'downloading eng.traineddata.gz') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
      //       } else if (packet.status === 'unzipping eng.traineddata.gz') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
      //       } else if (packet.status === 'loading eng.traineddata') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
      //       } else if (packet.status === 'initializing api') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
      //       } else if (packet.status === 'recognizing text') {
      //         that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
      //       }
      //       that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
      //     })
      //     .then(function (data) {
      //       that.newOCRTextData = data.text
      //       that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
      //       that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
      //       that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
      //     })
      //   }, function () { console.log('---------error---------') })
      // } else {
      //   Tesseract.workerOptions.workerPath = 'https://cdn.rawgit.com/naptha/tesseract.js/1.0.10/dist/worker.js'
      //   Tesseract.workerOptions.langPath = 'https://cdn.rawgit.com/naptha/tessdata/gh-pages/3.02/'
      //   Tesseract.workerOptions.corePath = 'https://cdn.rawgit.com/naptha/tesseract.js-core/0.1.0/index.js'
      //
      //   Tesseract.recognize(document.getElementById('pdf-canvas'), {
      //     lang: 'eng'
      //   })
      //   .progress(function (packet) {
      //     console.info(packet)
      //     if (packet.status === '') {
      //     } else if (packet.status === 'loading tesseract core') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), packet.progress * 10)
      //     } else if (packet.status === 'initializing tesseract') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 10 + packet.progress * 10)
      //     } else if (packet.status === 'downloading eng.traineddata.gz') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 20 + packet.progress * 10)
      //     } else if (packet.status === 'unzipping eng.traineddata.gz') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 30 + packet.progress * 10)
      //     } else if (packet.status === 'loading eng.traineddata') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 40 + packet.progress * 10)
      //     } else if (packet.status === 'initializing api') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 50 + packet.progress * 10)
      //     } else if (packet.status === 'recognizing text') {
      //       that.$f7.setProgressbar(that.$$(that.$$('.progressbar')[that.$$('.progressbar').length - 1]), 60 + packet.progress * 40)
      //     }
      //     that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text(packet.status)
      //   })
      //   .then(function (data) {
      //     that.newOCRTextData = data.text
      //     that.$$(that.$$('.progressbarContainer')[that.$$('.progressbarContainer').length - 1]).hide()
      //     that.$$(that.$$('.logListItem')[that.$$('.logListItem').length - 1]).text('OCR finished !')
      //     that.$$(that.$$('.importAttachmentButton')[that.$$('.importAttachmentButton').length - 1]).removeAttr('disabled')
      //   })
      //   .catch(error => {
      //     console.log(error)
      //   })
      // }
      /* eslint-enable no-undef */
    },
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>
<style scoped>
.fileContainer [type=file] {
    display: none;
    color: white;
}
.fileContainer {
  border: 1px solid ;
  text-decoration: none;
  text-align: center;
  border-radius: 27px;
  line-height: 25px;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  padding: 0 10px;
  margin: 0;
  height: 27px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  width: auto;
  float: right;
}
.attachmentImportButtonLength {
  width: 101px;
}
.progressbar {
  height: 8px;
}
/*
.col-md-offset-3 {
    margin-left: 25%;
    margin-top: 2%;

}*/

.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 90%
}

.button.button-round {
    border-radius: 27px;
    margin: auto;
}
.panel-heading {
    padding: 10px 15px;
    border-bottom: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-transform: uppercase;
}
</style>
